var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75037 0.831371C5.14783 0.387733 5.84256 0.387732 6.24001 0.83137L10.4967 5.58273C11.0737 6.22676 10.6166 7.25 9.75188 7.25H1.2385C0.37381 7.25 -0.0832959 6.22677 0.493689 5.58273L4.75037 0.831371Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileArrow);
export default __webpack_public_path__ + "static/media/ProfileArrow.05f3dc09bd8513d477322cdeea8b51ee.svg";
export { ForwardRef as ReactComponent };